export type TypeSocketConnectError = 'auth' | 'fatal' | 'retry';

const AUTH = ['unauthorized', 'token mancante', 'token non valido', 'token non valido o scaduto'];

const FATAL = ['origin-required', 'origin-not-allowed', 'forbidden', 'origin non ammessa', 'istanza non valida', 'ruolo non riconosciuto'];

export const socketConnectError = (error: unknown): TypeSocketConnectError => {
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
    if (AUTH.includes(message)) return 'auth';
    if (FATAL.includes(message)) return 'fatal';
    return 'retry';
};

export default socketConnectError;
